import { Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import {
	LoadingSpinner,
	Button,
	NoData,
	CommunityPartnerTopJobCard
} from 'Elements';
import styles from 'partials/homepage/section/staff-section.module.scss';
// import { useModal } from 'src/hooks/useModal';
import { Colors, CommunityPartnerMe } from 'Types';
import { useEffect, useState } from 'react';
import { useSearchJobs } from 'src/hooks/useJob';
import { Title } from 'src/containers/Styles';
import { clx } from 'src/helpers/Utils';

type Props = {
	isLoadingProfile: boolean;
	isFetchingProfile: boolean;
	communityPartnerMe: CommunityPartnerMe;
	agentId: string;
	topJobs: {
		enabled: boolean;
		headline: string;
	};
};

export const CommunityPartnerPreviewTopJopSection = ({
	isLoadingProfile,
	communityPartnerMe,
	agentId,
	topJobs
}: Props) => {
	const { t } = useTranslation();
	const perRow = 15;
	const [next, setNext] = useState(perRow);
	const [loading, setLoading] = useState(false);
	const { data, isLoading } = useSearchJobs({
		pageNumber: 1,
		pageSize: next,
		keyword: '',
		jobTags: [],
		jobActivities: [],
		locations: [],
		kind: null,
		postalCode: '',
		lon: null,
		lat: null,
		distance: null,
		topJob: true,
		businessSectors: [],
		...(communityPartnerMe?.commissionGroupInfo?.isPremium && {
			communityPartnerId: agentId
		}),
		categories: []
	});

	const handleMore = () => {
		setLoading(true);
		setNext(next + perRow);
	};

	useEffect(() => {
		setLoading(false);
	}, [next]);

	return (
		<section className="position-relative bg-gray-1 pt-4 pb-5">
			<Container>
				{isLoadingProfile ||
					(isLoading && (
						<div className="d-flex align-items-center justify-content-center">
							<LoadingSpinner />
						</div>
					))}
				{!isLoadingProfile && (
					<div
						className={clx(
							styles.title,
							'd-flex flex-column justify-content-center mx-auto mb-5'
						)}>
						<Title
							textColor="text-gray-5"
							className="h3 fw-700 mb-0 text-center">
							{topJobs?.headline}
						</Title>
					</div>
				)}
				{!isLoadingProfile && !isLoading && !loading && (
					<>
						{data && data?.results?.length > 0 && (
							<Row>
								{data?.results?.slice(0, next)?.map((job) => {
									return (
										<CommunityPartnerTopJobCard
											key={job?.document?.jobId}
											job={job?.document as any}
										/>
									);
								})}
							</Row>
						)}
						{data?.results && data?.totalCount > next && (
							<div className="d-flex align-items-center justify-content-center mt-3 gap-3">
								<Button
									size="lg"
									color={Colors['border-gray-4']}
									label={t('button.more-jobs') as string}
									className="rounded-pill"
									onClick={handleMore}
								/>
							</div>
						)}
						{data && data?.totalCount === 0 && (
							<NoData message={t('title.no-job')} />
						)}
					</>
				)}
			</Container>
		</section>
	);
};
